import { render, staticRenderFns } from "./showStops-editor.vue?vue&type=template&id=24139f8e&scoped=true&"
import script from "./showStops-editor.vue?vue&type=script&lang=js&"
export * from "./showStops-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24139f8e",
  null
  
)

export default component.exports